import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

import authReducer from './reducers/auth'
import globalReducer from './reducers/global'
import miscReducer from './reducers/misc'
import finalScanReducer from './reducers/FinalScan'
import searchRetrieveReducer from './reducers/SearchAndRetrieve'
import stuffReducer from './reducers/Stuff'
import ReprintToolReducer from './reducers/ReprintTool'
import QaReducer from './reducers/Qa'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  combineReducers({
    global: globalReducer,
    auth: authReducer,
    misc: miscReducer,
    finalScan: finalScanReducer,
    searchRetrieve: searchRetrieveReducer,
    stuff: stuffReducer,
    reprintTool: ReprintToolReducer,
    qa: QaReducer
  }),
  composeEnhancers(applyMiddleware(thunk))
)

export default store
